import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/product/[slug]/ProductClientLayout.tsx");
